import { z } from "zod";

export const transcriptTypeEnum = z.enum(["vtt", "txt"]);

export type TranscriptType = z.infer<typeof transcriptTypeEnum>;
